import { useAuth0 } from '@auth0/auth0-react';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { getGeometriesContaining } from '@/apis/geometries';
import { PRETTY_GEOM_TYPES } from '@/constants/filterCriteria/location';
import { domainCodeAtom } from '@australiangreens/ag-internal-components';
import { labelSorting } from '@/util/labelSorting';

export const useLookupGeometries = () => {
  const { getAccessTokenSilently, user } = useAuth0();
  const domainCode = useAtomValue(domainCodeAtom);

  return useCallback(
    // eslint-disable-next-line react-hooks/preserve-manual-memoization -- lookup identity must stay stable for autocomplete
    async (lookupValue: string) => {
      const subFilter =
        user?.sub && domainCode ? { sub: user.sub, domainCode: domainCode } : undefined;
      const token = await getAccessTokenSilently();
      return (await getGeometriesContaining(token, lookupValue, subFilter))
        .map((x) => {
          return {
            id: x.id,
            geometryType: x.geometryType,
            label: `${x.label} [${PRETTY_GEOM_TYPES[x.geometryType]}]`,
          };
        })
        .sort(labelSorting);
    },
    [domainCode, getAccessTokenSilently, user?.sub]
  );
};
